import { lazy } from '@/service/lazy'

export default [{
  name: 'Usuários Ativos',
  path: 'relatorio-usuarios',
  id: 'relatorio-usuarios',
  icon: 'fa fa-user',
  component: lazy('app/default/relatorios/usuariosativos/index'),
  meta: { requireAuth: true, rules: ['gerenciar_unidade'], root: true },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/usuariosativos.js